"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LSFileType = exports.FileProvider = void 0;
var FileProvider;
(function (FileProvider) {
    FileProvider["AWS"] = "aws";
    FileProvider["GCP"] = "gsp";
    FileProvider["SSH"] = "ssh";
    FileProvider["BaseSpace"] = "basespace";
    FileProvider["GEO"] = "geo";
    FileProvider["Globus"] = "globus";
    FileProvider["Dropbox"] = "dropbox";
    FileProvider["GoogleDrive"] = "googledrive";
})(FileProvider || (exports.FileProvider = FileProvider = {}));
var LSFileType;
(function (LSFileType) {
    LSFileType["Dir"] = "directory";
    LSFileType["Executable"] = "executable";
    LSFileType["Symlink"] = "symlink";
    LSFileType["File"] = "file";
    LSFileType["Unknown"] = "unknown";
})(LSFileType || (exports.LSFileType = LSFileType = {}));
